import React from "react";

//package import

import { createTheme, responsiveFontSizes, ThemeProvider } from "@mui/material";

//user import

import shadows from "./shadows";
import palette from "./palette";
import { liteThemeColors } from "./color";
import { useDarkMode } from "./useTheme";

const getTheme = (mode = "light") =>
  responsiveFontSizes(
    createTheme({
      palette: palette(mode),
      layout: {
        contentWidth: 1236,
      },
      shadows: shadows(mode),
      typography: {
        fontFamily: '"Inter", sans-serif',
        button: {
          textTransform: "none",
          fontWeight: "medium",
        },
      },
      zIndex: {
        appBar: 1200,
        drawer: 1300,
      },

      components: {
        MuiButton: {
          variants: [
            {
              props: { color: "secondary", variant: "contained" },
              style: {
                backgroundColor:
                  mode === "light" ? liteThemeColors?.secondary : "GrayText",
                ":hover": {
                  backgroundColor:
                    mode === "light" ? liteThemeColors?.secondary : "GrayText",
                },
              },
            },
          ],
        },
      },
    })
  );

const Theme = ({ children }) => {
  const [themeMode] = useDarkMode();
  return <ThemeProvider theme={getTheme(themeMode)}>{children}</ThemeProvider>;
};

export default Theme;
